import { observer } from 'mobx-react-lite'
import { TaskTemplatesShadcnComponent } from 'app/components/task-templates/TaskTemplatesShadcnComponent'
import { useTaskTemplates } from 'app/components/task-templates/useTaskTemplates'

// The Tasks tab of the templates hub (/settings/templates).
const SettingsTemplatesTasks = observer(function SettingsTemplatesTasks() {
  const props = useTaskTemplates()
  return <TaskTemplatesShadcnComponent {...props} />
})

export default SettingsTemplatesTasks
